export var MAX_PROGRESS = 100;
export var MIN_STEPS = 2;
export var MAX_STEPS = 7;
export var checkNbSteps = function (steps) {
    if (steps.length < MIN_STEPS || steps.length > MAX_STEPS) {
        throw new Error("ProgressBar needs at least " + MIN_STEPS + " step and at most " + MAX_STEPS);
    }
};
